import {MathLerp, MathMap} from "../../../libs/math-utils";
import {isScreenPc} from "../../../libs/helper";
import services from "../../../libs/services";

export class ServicePageItem {
    constructor({el}) {
        this.DOM = {el};
        this.DOM.thumbnail = this.DOM.el.querySelector('.js-servicePageItem_header_thumbnail_inner');
        this.DOM.header = this.DOM.el.querySelector('.js-servicePageItem_header');
        this.DOM.content = this.DOM.el.querySelector('.js-servicePageItem_content');
        this.DOM.wrapper = this.DOM.el.querySelector('.js-servicePageItem_wrapper');

        this.styles = {disTop: 0, scale: 1};
        this.props = {top: 0};
    }

    setProps() {
        const scrollTop = Math.abs(services.smooth_scrolling_instance);
        const {top, bottom, height} = this.DOM.el.getBoundingClientRect();
        this.props.top = top + scrollTop;
        this.props.bottom = bottom;
        this.props.height = height;

        this.props.headerHeight = this.DOM.header.getBoundingClientRect().height;
    }

    scrolling(instance, wrapOffsetTop, isScroll) {

        const disTop = Math.round((this.props.top - wrapOffsetTop - Math.abs(instance)));
        if (isScroll) {

            const heightContent = this.props.height - this.props.headerHeight;
            const disTopTran = Math.max(Math.min(disTop, 0), -heightContent);
            this.DOM.el.style.transform = `translate3d(0, ${Math.abs(disTopTran)}px, 0)`;

            if (Math.abs(disTopTran) < heightContent) {
                this.DOM.content.style.opacity = `1`;
            } else {
                this.DOM.content.style.opacity = `0`;
            }
        }

        if (disTop < -150) {
            const scale = MathMap(Math.abs(instance) - (this.props.top - wrapOffsetTop), 150, (this.props.height - this.props.headerHeight), 1, (153 / 307));
            this.DOM.thumbnail.style.transform = `scale(${Math.min(1, Math.max(scale, (153 / 307)))})`;

            const tranHeader = MathMap(Math.abs(instance) - (this.props.top - wrapOffsetTop), 150 + 100, (this.props.height - this.props.headerHeight) + 100, 0, 8); //2.5
            this.DOM.header.style.transform = `translateY(${-tranHeader}%)`;

        } else if (disTop > 0) {
            const scale = MathMap(disTop, 0, (this.props.height - this.props.headerHeight - 220), 1, (153 / 307));
            this.DOM.thumbnail.style.transform = `scale(${Math.min(1, Math.max(scale, (153 / 307)))})`;
        }
    }

    pageEnter(wrapOffsetTop) {
        this.setProps();
        this.scrolling(0, wrapOffsetTop, true);
    }

    onResize() {
        if (!isScreenPc()) {
            this.clearStyle();
        } else {
            this.setProps();
        }
    }

    clearStyle() {
        this.DOM.thumbnail.style.transform = null;
        this.DOM.el.style.transform = null;
    }
}